import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { TranslatePipe } from '../../pipes/trans.pipe';

@Component({
  selector: 'app-keyboard',
  standalone: true,
  imports: [
    TranslatePipe
  ],
  templateUrl: './keyboard.component.html',
  styleUrl: './keyboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KeyboardComponent extends BaseComponent {

  @Input({ required: true }) isSimple: boolean;

  @Output() keyClick = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();
  @Output() deleteBack = new EventEmitter<void>();
}
